type VerifyEmailLayout = 'dashboard' | 'landing'

/**
 * Keep partner email verification inside the dashboard while preserving the
 * consumer-facing layout for customer sessions.
 */
export const resolveVerifyEmailLayout = (
  isAuthenticated: boolean,
  isCustomerRole: boolean
): VerifyEmailLayout => (isAuthenticated && !isCustomerRole ? 'dashboard' : 'landing')
